// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3zTWP","title":"Header_title__3Q2ID","side":"Header_side__3qbI9"};